import { Injectable } from '@angular/core';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { LocalStorageService } from '../services/local-storage.service';
import { LocalStorageVariablesKeys } from '../enums/local-storage-variables.meta';

export interface Locale {
    lang: string;
    data: unknown;
}

@Injectable({
    providedIn: 'root',
})
export class TranslationService {
    private langIds = [];

    constructor(
        private translate: TranslateService,
        private localStorageService: LocalStorageService,
    ) {
        this.translate.addLangs(['en']);
        this.translate.setDefaultLang('it');
    }

    loadTranslations(...args: Locale[]): void {
        const locales = [...args];

        locales.forEach((locale) => {
            this.translate.setTranslation(locale.lang, locale.data as TranslationObject, true);
            this.langIds.push(locale.lang);
        });

        this.translate.addLangs(this.langIds);
    }

    setLanguage(lang: string): void {
        if (lang) {
            this.translate.use(this.translate.getDefaultLang());
            this.translate.use(lang);
            this.localStorageService.setItemToLocalStorage(LocalStorageVariablesKeys.LOCALIZATION_STORAGE_KEY, lang);
        }
    }

    getSelectedLanguage(): string {
        return (
            this.localStorageService.getItemFromLocalStorage(LocalStorageVariablesKeys.LOCALIZATION_STORAGE_KEY) ||
            this.translate.getDefaultLang()
        );
    }
}
